import React from 'react';
import type { CardListId } from '../../../model/types';
import { useBacklogSelector } from '../../../state';
import { getTimeTrackingOptions } from '../../../state/selectors/app';
import { getOrderedCardIdsByCardListId } from '../../../state/selectors/cards';
import { getColumnCount, getColumns } from '../../../state/selectors/columns';
import { getEstimationName, getEstimationType } from '../../../state/selectors/estimation';
import { makeGetSprintEstimations } from '../../../state/selectors/sprints';
import { useIsCMPBacklog } from '../../../state/state-hooks/capabilities';
import { Estimations } from './view';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ cardListId }: { cardListId: CardListId }) => {
	const columns = useBacklogSelector(getColumns);
	const estimations = useBacklogSelector((state) =>
		columns !== null ? makeGetSprintEstimations(state)(cardListId) : null,
	);
	const estimationType = useBacklogSelector(getEstimationType);
	const timeTrackingOptions = useBacklogSelector(getTimeTrackingOptions);
	const isCompanyManaged = useIsCMPBacklog();
	const estimationName = useBacklogSelector(getEstimationName);
	const totalEstimations = estimations ? Object.values(estimations).reduce((a, b) => a + b, 0) : 0;
	const cardOrder = useBacklogSelector(getOrderedCardIdsByCardListId);
	const totalCards = cardOrder[cardListId]?.length ?? 0;
	const columnCounts = isCompanyManaged ? getColumnCount(columns) : undefined;
	const props = {
		estimations,
		estimationType,
		timeTrackingOptions,
		isCompanyManaged,
		estimationName,
		totalEstimations,
		totalCards,
		columnCounts,
	};

	return <Estimations {...props} />;
};
